import React, { useState, useEffect } from "react";
import { FaUser } from "react-icons/fa";
import NorthArrow from "./NorthArrow";
import LoginModal from "../Auth/LoginModal";
import UserProfile from "../User/UserProfile";
import HeartIcon from "../Icons/HeartIcon";
import { API_CONFIG } from "../../config/constants";
import "./RightControls.css";

const RightControls = ({ mapRef, language = "ar", onShowFavorites }) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if user is logged in
  useEffect(() => {
    const checkAuthStatus = () => {
      const user = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      setIsLoggedIn(user && token);
    };

    // Check initially
    checkAuthStatus();

    // Listen for storage changes (when user logs in/out in another tab)
    window.addEventListener('storage', checkAuthStatus);

    // Listen for custom auth events
    window.addEventListener('authStatusChanged', checkAuthStatus);

    return () => {
      window.removeEventListener('storage', checkAuthStatus);
      window.removeEventListener('authStatusChanged', checkAuthStatus);
    };
  }, []);

  const handleLoginClick = () => {
    setIsLoginModalOpen(true);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setIsLoginModalOpen(false);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event('authStatusChanged'));
  };

  const handleProfileClick = () => {
    setIsUserProfileOpen(true);
  };

  const handleProfileClose = () => {
    setIsUserProfileOpen(false);
  };

  const handleFavoritesClick = () => {
    if (onShowFavorites) {
      onShowFavorites();
    }
  };

  return (
    <>
      <div className="right-controls">
        {/* North Arrow */}
        <NorthArrow mapRef={mapRef} />

        {/* Login Button - Only show if user is not logged in */}
        {!isLoggedIn && (
          <button
            className="control-btn login-btn"
            onClick={handleLoginClick}
            title={language === 'ar' ? 'تسجيل الدخول' : 'Login'}
          >
            <span className="control-icon">
              <img src="/map_controls/Login v3.png" alt="Login" className="control-icon-img" />
            </span>
          </button>
        )}

        {/* User Profile and Favorites - Only show if user is logged in */}
        {isLoggedIn && (
          <>
            {/* Profile Button */}
            <button
              className="control-btn profile-btn"
              onClick={handleProfileClick}
              title={language === 'ar' ? 'الملف الشخصي' : 'Profile'}
            >
              <span className="control-icon">
                <img src="/user white v2.png" alt="Profile" className="control-icon-img" />
              </span>
            </button>

            {/* Favorites Button */}
            <button
              className="control-btn favorites-btn"
              onClick={handleFavoritesClick}
              title={language === 'ar' ? 'المفضلة' : 'Favorites'}
            >
              <span className="control-icon">
                <HeartIcon filled={true} size={30} color="white" />
              </span>
            </button>
          </>
        )}
      </div>

      {/* Login Modal */}
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onSuccess={handleLoginSuccess}
        language={language}
      />

      {/* User Profile Modal */}
      <UserProfile
        isOpen={isUserProfileOpen}
        onClose={handleProfileClose}
        language={language}
      />
    </>
  );
};

export default RightControls;
